import PreviewCandidateModal from "./PreviewCandidateModal"

export default PreviewCandidateModal
